import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {path: '', pathMatch : 'full', redirectTo: '/login'},
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'renew-expired-password',
    loadChildren: () => import('./pages/renew-expired-password/renew-expired-password.module').then( m => m.RenewExpiredPasswordPageModule)
  },
  {
    path: 'installation',
    loadChildren: () => import('./pages/installation/installation.module').then( m => m.InstallationPageModule)
  },
  {
    path: 'updates',
    loadChildren: () => import('./pages/updates/updates.module').then( m => m.UpdatesPageModule)
  },
  {
    path: 'views',
    loadChildren: () => import('./pages/views/views.module').then(m => m.ViewsPageModule)
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
